// The words for an aircraft's make, model and year as the server handed them
// (services/aircraft-identity-label.service.js: the identity record's, with
// identity_label_state). Derives no fact: an absent label says why it is
// absent, so "not on file" and "could not be read" never look alike, and
// neither looks like an aircraft with no make.
const STATE_WORDS = {
  empty: 'make and model not on file',
  missing: 'no identity record',
  unread: 'make and model could not be read',
};

export function aircraftLabel(a, fallback = '—') {
  if (!a) return fallback;
  const label = [a.year, a.make_model].filter(Boolean).join(' ');
  if (a.make_model) return label;
  return STATE_WORDS[a.identity_label_state] || label || fallback;
}
